import { parseDatetoFormatSend, formatoFechaTimeZoneLocal } from "components/UsuarioGeneral/Vacaciones/Planificacion Vacaciones/PlanificacionVacaciones";
import { format, parseISO,addDays,addMonths } from "date-fns";
import es from 'date-fns/locale/es';
import add from 'date-fns/add'
import differenceInMinutes from 'date-fns/differenceInMinutes'

export type MesesObjeto = {
    mes:string,
    valorMes:number
}

export const listadoMeses:MesesObjeto[] = [
    {
        mes:"Enero",
        valorMes:1
    },
    {
        mes:"Febrero",
        valorMes:2
    },
    {
        mes:"Marzo",
        valorMes:3
    },
    {
        mes:"Abril",
        valorMes:4
    },
    {
        mes:"Mayo",
        valorMes:5
    },
    {
        mes:"Junio",
        valorMes:6
    },
    {
        mes:"Julio",
        valorMes:7
    },
    {
        mes:"Agosto",
        valorMes:8
    },
    {
        mes:"Septiembre",
        valorMes:9
    },
    {
        mes:"Octubre",
        valorMes:10
    },
    {
        mes:"Noviembre",
        valorMes:11
    },
    {
        mes:"Diciembre",
        valorMes:12
    }
]

export function ObtenerUltimaFechaMesAnterior(): Date {
    const hoy = new Date();
    return new Date(hoy.getFullYear(), hoy.getMonth(), 0); // Día 0 del mes actual es el último día del mes anterior
}

export function ObtenerFechaFromIsoFormat(fechaOriginal: string | undefined | null) {
    if (!fechaOriginal) {
        return ""
    }
    var fecha_dividida: string[] = fechaOriginal.split("T")[0].split("-");
    return (fecha_dividida[2] + "/" + fecha_dividida[1] + "/" + fecha_dividida[0])
}

export function FormatoDiaMesFecha(fechaOriginal: string | undefined | null) {
    if (!fechaOriginal) {
        return ""
    }
    const date = new Date(fechaOriginal);

    const day = date.getDate();
    const month = listadoMeses.filter((v) => v.valorMes === date.getMonth() + 1)[0].mes;

    return `${day} de ${month.toLowerCase()}`;
}

export function FormatoDiaMesAnioFecha(fechaOriginal: string | undefined | null) {
    if (!fechaOriginal) {
        return ""
    }
    const date = new Date(fechaOriginal);

    const day = date.getDate();
    const month = listadoMeses.filter((v) => v.valorMes === date.getMonth() + 1)[0].mes;
    const year = date.getFullYear();
    return `${day} de ${month.toLowerCase()} del ${year}`;
}


export function GetDateObjectFromIsoFormat(originalDate: string | undefined|null) {
    if (!originalDate) {
        return undefined
    }
    const fecha_dividida: string[] = originalDate.split("T")[0].split("-");

    return new Date(+fecha_dividida[0], +fecha_dividida[1] - 1, +fecha_dividida[2]);
}

export function GetDateObjectFromDate(originalDate: Date | undefined | null): Date | undefined {
    if (!(originalDate instanceof Date) || isNaN(originalDate.getTime())) {
        return undefined;
    }

    return new Date(originalDate.getFullYear(), originalDate.getMonth(), originalDate.getDate());
}


export function ObtenerFechaFormatoLocal(fechaOriginal: Date) {
    var algo = fechaOriginal.toLocaleString("es-EC", {
        //timeZone: 'America/Bogota',
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
    return algo;
}

export function ParseFechaToUsaFormat(fechaOriginal: Date) {
    
    var algo = fechaOriginal.toLocaleString("en-US", {
        timeZone: 'America/Bogota',
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
    return algo;
}

export function ObtenerFechaTimeZoneLocalISO(fechaOriginal: Date) {

    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaOriginal);
    

    var partesFecha = string_FechaActualLocalZone.split("/");
    var fechaISO = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}T00:00:00Z`    
    

    return fechaISO;
}

export function PruebaSolucion(fechaOriginal: Date) {
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaOriginal);
    var partesFecha = string_FechaActualLocalZone.split("/");
    var fecha = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}T00:00:00`
    return (new Date(fecha))
}

export function PruebaSolucion2(fechaOriginal: Date | string) {

    if (typeof (fechaOriginal) !== "string") {
        var offset = fechaOriginal.getTimezoneOffset()
        var difference = -offset * 60 * 1000;
        return new Date(fechaOriginal.getTime() + difference).toISOString();
    }
    else{
        return ""
    }

}

export function PruebaSolucion3(fechaOriginal: Date | string | null) {

    if (fechaOriginal && typeof (fechaOriginal) !== "string") {
        var fechastring = String(fechaOriginal)
        var fechareverse = fechastring.split('/').reverse().join('-');
        var fecharespuesta = new Date(String(fechareverse))
        return fecharespuesta.toJSON();
    }
    else {
        return ""
    }
}

export function AgregarHoraAFecha(fechaOriginal: Date,horasAgregar:string){
    //Considerar el formato de horasAgregar como el sgte : HH:MM
    const [hora, minuto] = horasAgregar.split(":");
    
    if(hora === undefined || hora === "" || minuto === undefined || minuto === ""){
        return fechaOriginal;
    }

                
    const fechaConHora = add(fechaOriginal, { hours: +hora, minutes: +minuto });
    
    return fechaConHora;

}

export function ParseHorasFormato(horaOriginal: string) {

    if (!horaOriginal) {
        return ""
    }

    const [hora, minuto] = horaOriginal.split(":");
    
    if(hora === undefined || hora === "" || minuto === undefined || minuto === ""){
        return horaOriginal;
    }
    else{
        return `${hora}:${minuto}`;
    }
}

export function sendDateToBackend(fechaOriginal: Date) {
    var dia = fechaOriginal.getDate();
    var mes = fechaOriginal.getMonth() + 1;
    var anio = fechaOriginal.getFullYear();
    var diaString: string = dia < 10 ? 0 + dia.toString() : dia.toString();
    var mesString: string = mes < 10 ? 0 + mes.toString() : mes.toString();
    var fecha = `${diaString}/${mesString}/${anio} 00:00:00`
    return fecha;
}


export function ObtenerFechaNoDiasFromIsoFormat(fechaOriginal: string | undefined) {
    if (!fechaOriginal) {
        return ""
    }
    var fecha_dividida: string[] = fechaOriginal.split("T")[0].split("-");


}

export function ParseFechaMesesFromIsoFormat(fechaOriginal: string | undefined) {
    if (!fechaOriginal) {
        return ""
    }
    var fechaOriginalDate = new Date(SimulateUTCFormat(fechaOriginal));
    var fechaFormateada = fechaOriginalDate.toLocaleString("es-US", {
        timeZone: 'UTC',
        month: "long",
        year: "numeric",
    })

    // var isoParse = parseISO(fechaOriginal);
    // var fechaFormateada = format(isoParse,"MMMM yyyy",{locale:es})
    return fechaFormateada;
}

export function SimulateUTCFormat(fechaOriginal: string) {
    var len = fechaOriginal.length;
    if (fechaOriginal.charAt(len - 1) !== 'Z') {
        return fechaOriginal + "Z"
    }
    return fechaOriginal
}

export function formatDateToString(fechaString) {
    // Obtener los componentes de la fecha (d�a, mes y a�o)

    var fecha = new Date(fechaString);
    var dia = fecha.getDate();
    var mes = fecha.getMonth() + 1; // Los meses en JavaScript van de 0 a 11, por lo que sumamos 1
    var anio = fecha.getFullYear();

    // Formatear la fecha al formato "dd/mm/yyyy"
    var fechaFormateada = (dia < 10 ? '0' : '') + dia + '/' + (mes < 10 ? '0' : '') + mes + '/' + anio;

    return fechaFormateada;
}		
		
		
function GetTodayDateDatePicker() {
    var fechaActual = new Date();
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaActual);
    var partesFecha = string_FechaActualLocalZone.split("/");
    return `${partesFecha[2]}/${partesFecha[1]}/${partesFecha[0]}`
}

export function GetTodayDateForDatePicker() {
    return GetTodayDateDatePicker();
}
export function GetTodayDateDifferenceForDatePicker(cantidadDiasAgregar: number) {
    var fechaActual = new Date();
    fechaActual.setDate(fechaActual.getDate() + +cantidadDiasAgregar);
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaActual);
    var partesFecha = string_FechaActualLocalZone.split("/");
    var fechanueva = `${partesFecha[2]}/${partesFecha[1]}/${partesFecha[0]}`
    return fechanueva;

}

export function obtener_rango_fechas_no_weekend(inicial: Date, final: Date) {

    var rango_escogido: Array<Date> = [];
    var fecha_inicial = new Date(inicial)
    var fecha_final = new Date(final)
    rango_escogido.push(fecha_inicial)
    var diferencia_en_tiempo = fecha_final.getTime() - fecha_inicial.getTime();

    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
    for (let index = 0; index < diferencia_en_dias; index++) {
        fecha_inicial = addDays(fecha_inicial, 1)
        if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) rango_escogido.push(fecha_inicial);

    }

    return rango_escogido;

}

export function obtener_rango_fechas_with_weekend(inicial: Date, final: Date) {

    var rango_escogido: Array<Date> = [];
    var fecha_inicial = new Date(inicial)
    var fecha_final = new Date(final)
    rango_escogido.push(fecha_inicial)
    var diferencia_en_tiempo = fecha_final.getTime() - fecha_inicial.getTime();

    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
    for (let index = 0; index < diferencia_en_dias; index++) {
        fecha_inicial = addDays(fecha_inicial, 1)
    }

    return rango_escogido;

}

type FechaHora = {
    fecha:Date,
    horaInicio:string,
    horaFin:string
}

export function obtener_rango_fechas_horas_no_weekend(inicial: Date, final: Date, horainicio:string,horafin:string) {

    var rango_escogido: Array<FechaHora> = [];
    var fecha_inicial = new Date(inicial)
    var fecha_final = new Date(final)
    rango_escogido.push({fecha:fecha_inicial,horaInicio:horainicio,horaFin:horafin})
    var diferencia_en_tiempo = fecha_final.getTime() - fecha_inicial.getTime();

    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);
    for (let index = 0; index < diferencia_en_dias; index++) {
        fecha_inicial = addDays(fecha_inicial, 1)
        if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) rango_escogido.push({fecha:fecha_inicial,horaInicio:horainicio,horaFin:horafin});

    }

    return rango_escogido;

}

export function SumarMesesFecha(fecha: Date|string, valor: number) {
    const parseFecha = typeof(fecha) === "string" ? new Date(fecha) : fecha;
    return addMonths(parseFecha, valor)
}

export function SumarDiasFecha(fecha: Date|string, valor: number) {
    const parseFecha = typeof(fecha) === "string" ? new Date(fecha) : fecha;
    return addDays(parseFecha, valor)
}

export function ObtenerFechaLaboralDeSuma(fecha: Date | string, valor: number, feriados: any[]) {
    var feriadosParse: Date[] = [];

    if (feriados.length > 0) {
            feriadosParse = feriados.map((v) => {
                return new Date(v);
            })
    }


    var parseFecha = typeof (fecha) === "string" ? new Date(fecha) : fecha;
    parseFecha = new Date(parseFecha.getFullYear(), parseFecha.getMonth(), parseFecha.getDate(), 0, 0, 0);
    var diasAgregar = valor;

    if (diasAgregar > 0) {
        while (diasAgregar > 0) {

            parseFecha = addDays(parseFecha, 1);

            if (parseFecha.getDay() === 0 || parseFecha.getDay() === 6 || feriadosParse.find(f => f.getTime() === parseFecha.getTime()) !== undefined) {
                ;
            }
            else {
                diasAgregar -= 1;
            }


        }
    } else if (diasAgregar < 0) {
        while (diasAgregar < 0) {

            parseFecha = addDays(parseFecha, -1);

            if (parseFecha.getDay() === 0 || parseFecha.getDay() === 6 || feriadosParse.find(f => f.getTime() === parseFecha.getTime()) !== undefined) {
                ;
            }
            else {
                diasAgregar += 1;
            }


        }
    }

    

    return parseFecha;

}

export function obtenerFechaLaboralSinFeriados(fecha: Date | string, valor: number, feriados: any[]) {
    var feriadosParse: Date[] = [];

    if (feriados.length > 0) {
        feriadosParse = feriados.map((v) => {
            return new Date(v);
        })
    }

    var parseFecha = typeof (fecha) === "string" ? new Date(fecha) : fecha;
    parseFecha = new Date(parseFecha.getFullYear(), parseFecha.getMonth(), parseFecha.getDate(), 0, 0, 0);
    var diasAgregar = valor;

    if (diasAgregar > 0) {
        while (diasAgregar > 0) {

            parseFecha = addDays(parseFecha, 1);

            if (parseFecha.getDay() === 0 || parseFecha.getDay() === 6 || feriadosParse.find(f => f.getTime() === parseFecha.getTime()) !== undefined) {
                ;
            }
            else {
                diasAgregar -= 1;
            }


        }
    } else if (diasAgregar < 0) {
        while (diasAgregar < 0) {

            parseFecha = addDays(parseFecha, -1);

            if (feriadosParse.find(f => f.getTime() === parseFecha.getTime()) !== undefined) {
                ;
            }
            else {
                diasAgregar += 1;
            }
        }
    }

    return parseFecha;
}



export function GetPreviousLaboralDay(fecha: Date, feriados: Date[]): Date{

    var nuevaFecha = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    nuevaFecha = addDays(nuevaFecha, -1);
    var day = nuevaFecha.getDay();

    while( day === 0 || day === 6 || feriados.find(f => f.getTime() === nuevaFecha.getTime()) !== undefined ){
        nuevaFecha = addDays(nuevaFecha,-1);
        day = nuevaFecha.getDay();
    }
    return nuevaFecha;
}
export function GetNPreviousLaboralDay(fecha: Date, feriados: Date[],ndias:number): Date{

    var nuevaFecha = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 0, 0, 0);

    var ndiasrestantes = ndias;
    var day = nuevaFecha.getDay();

    while (day === 0 || day === 6 || feriados.find(f => f.getTime() === nuevaFecha.getTime()) !== undefined || ndiasrestantes > 0){
        nuevaFecha = addDays(nuevaFecha,-1);
        day = nuevaFecha.getDay();
        const finSemanaFeriado = day === 0 || day === 6 || feriados.find(f => f.getTime() === nuevaFecha.getTime()) !== undefined;
        if (!finSemanaFeriado) {
            ndiasrestantes -= 1;
        }        
    }
    return nuevaFecha;
}


export const function_calcular_dias_ordinarios = (fecha_inicio: Date, fecha_hasta: Date) => {
    var fecha_inicial = fecha_inicio
    var diferencia_en_tiempo = fecha_hasta.getTime() - fecha_inicio.getTime();

    // To calculate the no. of days between two dates
    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);

    var contador_dias_ordinarios = 0;

    for (let index = 0; index < diferencia_en_dias; index++) {
        if (fecha_inicial.getDay() !== 0 && fecha_inicial.getDay() !== 6) contador_dias_ordinarios++;
        fecha_inicial = addDays(fecha_inicial, 1);
    }

    contador_dias_ordinarios++;
    return contador_dias_ordinarios;
}

export const function_calcular_dias = (fecha_inicio: Date, fecha_hasta: Date) => {
    var fecha_inicial = fecha_inicio
    var diferencia_en_tiempo = fecha_hasta.getTime() - fecha_inicio.getTime();

    // To calculate the no. of days between two dates
    var diferencia_en_dias = diferencia_en_tiempo / (1000 * 3600 * 24);

    var contador_dias_ordinarios = 0;

    for (let index = 0; index < diferencia_en_dias; index++) {
        contador_dias_ordinarios++;
        fecha_inicial = addDays(fecha_inicial, 1);
    }

    contador_dias_ordinarios++;
    return contador_dias_ordinarios;
}

export const function_calcular_dias_ordinarios_feriados = (fecha_inicio: Date, fecha_hasta: Date, feriados: Date[] = []) => {
    var fecha_inicial = new Date(fecha_inicio);
    var fecha_final = new Date(fecha_hasta);
    var contador_dias_ordinarios = 0;

    // Normalizar fechas para comparar solo día, mes y año
    const normalizarFecha = (fecha: Date) => {
        return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    };

    const fechaInicioNormalizada = normalizarFecha(fecha_inicial);
    const fechaHastaNormalizada = normalizarFecha(fecha_final);
    const feriadosNormalizados = feriados.map(feriado => normalizarFecha(feriado));

    // Iterar día por día
    let fechaActual = new Date(fechaInicioNormalizada);

    while (fechaActual <= fechaHastaNormalizada) {
        const diaSemana = fechaActual.getDay();
        const esFinDeSemana = diaSemana === 0 || diaSemana === 6;

        // Verificar si es feriado
        const fechaActualNormalizada = normalizarFecha(fechaActual);
        const esFeriado = feriadosNormalizados.some(feriado =>
            feriado.getTime() === fechaActualNormalizada.getTime()
        );

        // Contar solo si no es fin de semana y no es feriado
        if (!esFinDeSemana && !esFeriado) {
            contador_dias_ordinarios++;
        }

        // Avanzar al siguiente día
        fechaActual.setDate(fechaActual.getDate() + 1);
    }

    return contador_dias_ordinarios;
}

export const function_calcular_dias_feriados = (fecha_inicio: Date, fecha_hasta: Date, feriados: Date[] = []) => {
    var fecha_inicial = new Date(fecha_inicio);
    var fecha_final = new Date(fecha_hasta);
    var contador_dias_totales = 0;

    // Normalizar fechas para comparar solo día, mes y año
    const normalizarFecha = (fecha: Date) => {
        return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    };

    const fechaInicioNormalizada = normalizarFecha(fecha_inicial);
    const fechaHastaNormalizada = normalizarFecha(fecha_final);
    const feriadosNormalizados = feriados.map(feriado => normalizarFecha(feriado));

    // Iterar día por día
    let fechaActual = new Date(fechaInicioNormalizada);

    while (fechaActual <= fechaHastaNormalizada) {
        // Verificar si es feriado
        const fechaActualNormalizada = normalizarFecha(fechaActual);
        const esFeriado = feriadosNormalizados.some(feriado =>
            feriado.getTime() === fechaActualNormalizada.getTime()
        );

        // Contar solo si no es feriado
        if (!esFeriado) {
            contador_dias_totales++;
        }

        // Avanzar al siguiente día
        fechaActual.setDate(fechaActual.getDate() + 1);
    }

    return contador_dias_totales;
}

export function CompareDates(fechaInicio: Date, fechaFin: Date) {
    var fi = new Date(fechaInicio);
    var ff = new Date(fechaFin);

    if (fi.getTime() < ff.getTime()) {
        return -1
    }
    else if (fi.getTime() > ff.getTime()) {
        return 1

    }
    else {
        return 0
    }
}

export function overlaps_dates(fecha_inicio: Date, fecha_fin: Date, rango_fechas_escogidas: Array<Date>) {
    var arreglo_fechas: Array<Date> = obtener_rango_fechas_no_weekend(new Date(fecha_inicio), new Date(fecha_fin));
    var fechas: Array<Date> = rango_fechas_escogidas;
    var interseccion: Array<Date> = fechas.filter((fecha, index, array) => {
        var indice_encontrado = arreglo_fechas.findIndex((fecha_quitar) => { return fecha.getTime() == fecha_quitar.getTime() });
        return indice_encontrado != -1
    })
    if (interseccion.length !== 0) return true;
    return false;

}

export function overlaps_dates_with_weekend(fecha_inicio: Date, fecha_fin: Date, rango_fechas_escogidas: Array<Date>) {
    var arreglo_fechas: Array<Date> = obtener_rango_fechas_with_weekend(new Date(fecha_inicio), new Date(fecha_fin));
    var fechas: Array<Date> = rango_fechas_escogidas;
    var interseccion: Array<Date> = fechas.filter((fecha, index, array) => {
        var indice_encontrado = arreglo_fechas.findIndex((fecha_quitar) => { return fecha.getTime() == fecha_quitar.getTime() });
        return indice_encontrado != -1
    })
    if (interseccion.length !== 0) return true;
    return false;

}


export function toHoursAndMinutes(totalMinutes:number):string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
  
    return `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`;
  }
  

export function CompareRangeBetweenDatesAlmuerzo(fechaInicioComparar:Date,fechaFinComparar:Date,fechaInicio:Date,fechaFin:Date){
    //Divididas las comparaciones por letras
    const A = fechaInicio.getTime() <= fechaInicioComparar.getTime() 
    const B = fechaInicioComparar.getTime() < fechaFin.getTime()



    const C = (fechaInicio.getTime() <  fechaFinComparar.getTime() )
    
    
    const D = fechaFinComparar.getTime() <= fechaFin.getTime()
    const E = fechaInicioComparar.getTime() <= fechaInicio.getTime()
    const F = fechaFin.getTime() <= fechaFinComparar.getTime()


    return (A && B) || (C && D) || (A && D) || (E && F)
    
}



export function CompareRangeBetweenDates(fechaInicioComparar:Date,fechaFinComparar:Date,fechaInicio:Date,fechaFin:Date){
    //Divididas las comparaciones por letras
    return fechaInicio.getTime() <= fechaInicioComparar.getTime() && fechaFinComparar.getTime() <= fechaFin.getTime()
    
}

export function differenceInDays(date1: Date | string, date2: Date | string): number | null {
    // Convierte las fechas a objetos Date si son strings
    const date1Obj = typeof date1 === 'string' ? new Date(date1) : date1;
    const date2Obj = typeof date2 === 'string' ? new Date(date2) : date2;

    // Verifica si las fechas son v�lidas
    if (!(date1Obj instanceof Date) || !(date2Obj instanceof Date) || isNaN(date1Obj.getTime()) || isNaN(date2Obj.getTime())) {
        return null; // Devuelve null si alguna de las fechas no es v�lida
    }

    // Calcula la diferencia en milisegundos y luego convierte a d�as
    const diffTime = Math.abs(date2Obj.getTime() - date1Obj.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays + 1;
}

// Función para determinar si una fecha corresponde a un fin de semana
export function isWeekend(date: Date) {
    const day = date.getDay();
    return day === 0 || day === 6;
}

/**
 * Calcula la cantidad de días hábiles (excluyendo sábados y domingos)
 * entre dos fechas, incluyendo ambos extremos.
 *
 * @param date1 - La primera fecha (objeto Date o string).
 * @param date2 - La segunda fecha (objeto Date o string).
 * @returns La cantidad de días hábiles entre las fechas o null si alguna fecha es inválida.
 */
export function differenceInBusinessDays(date1: Date | string, date2: Date | string): number | null {
    // Conversión: si el parámetro es string, se convierte a Date.
    const date1Obj: Date = typeof date1 === 'string' ? new Date(date1) : date1;
    const date2Obj: Date = typeof date2 === 'string' ? new Date(date2) : date2;

    // Validación: verificar que ambas fechas sean válidas.
    if (isNaN(date1Obj.getTime()) || isNaN(date2Obj.getTime())) {
        return null;
    }

    // Determinar el rango: usar getTime() para comparar y crear nuevas instancias sin error.
    const startDate: Date = date1Obj.getTime() <= date2Obj.getTime()
        ? new Date(date1Obj.getTime())
        : new Date(date2Obj.getTime());
    const endDate: Date = date1Obj.getTime() <= date2Obj.getTime()
        ? new Date(date2Obj.getTime())
        : new Date(date1Obj.getTime());

    let businessDays: number = 0;
    // Crear una copia de startDate para iterar sin modificar el original.
    let currentDate: Date = new Date(startDate.getTime());

    // Iterar desde la fecha de inicio hasta la fecha final (inclusive)
    while (currentDate.getTime() <= endDate.getTime()) {
        const day = currentDate.getDay();
        // getDay() retorna 0 para domingo y 6 para sábado.
        if (day !== 0 && day !== 6) {
            businessDays++;
        }
        // Incrementar la fecha en 1 día.
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return businessDays;
}

export function NewdifferenceInBusinessDays(date1: Date | string, date2: Date | string): number | null {
    // Conversión
    const date1Obj: Date = typeof date1 === 'string' ? new Date(date1) : date1;
    const date2Obj: Date = typeof date2 === 'string' ? new Date(date2) : date2;

    // Validación
    if (isNaN(date1Obj.getTime()) || isNaN(date2Obj.getTime())) {
        return null;
    }

    // Normalizar ambas fechas a UTC para evitar problemas de zona horaria
    const utcDate1 = Date.UTC(
        date1Obj.getUTCFullYear(),
        date1Obj.getUTCMonth(),
        date1Obj.getUTCDate()
    );
    const utcDate2 = Date.UTC(
        date2Obj.getUTCFullYear(),
        date2Obj.getUTCMonth(),
        date2Obj.getUTCDate()
    );

    // Determinar el rango
    const startTime = Math.min(utcDate1, utcDate2);
    const endTime = Math.max(utcDate1, utcDate2);

    let businessDays: number = 0;
    let currentTime = startTime;

    // Iterar en milisegundos (1 día = 24 * 60 * 60 * 1000 ms)
    const ONE_DAY_MS = 24 * 60 * 60 * 1000;

    while (currentTime <= endTime) {
        const currentDate = new Date(currentTime);
        const day = currentDate.getUTCDay(); // Usar getUTCDay para consistencia
        if (day !== 0 && day !== 6) {
            businessDays++;
        }
        currentTime += ONE_DAY_MS;
    }

    return businessDays;
}
